import { getMainVolopsSearchRoutePath } from 'modules/main/helpers/searchRoute/getMainVolopsSearchRoutePath';

import { TakeActionDropdownData } from './TakeActionDropdownData';

export const takeActionDropdownDataEn: TakeActionDropdownData = {
  triggerText: 'Take Action',
  triggerHref: getMainVolopsSearchRoutePath({ lang: 'en' }),
  search: {
    title: 'Search',
    items: [
      {
        type: 'volop',
        icon: 'hand',
        title: 'Volunteer',
        href: getMainVolopsSearchRoutePath({ lang: 'en' }),
      },
      {
        type: 'event',
        icon: 'star-calendar',
        title: 'Attend an Event',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['EVENT'] },
        }),
      },
      {
        type: 'donations',
        icon: 'money',
        title: 'Give Donations',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['DONATION'] },
        }),
      },
      {
        type: 'petitions',
        icon: 'group',
        title: 'Sign Petitions',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['PETITION'] },
        }),
      },
      {
        type: 'loans',
        icon: 'loan',
        title: 'Make a Loan',
        href: getMainVolopsSearchRoutePath({
          lang: 'en',
          filters: { type: 'VOLOP', actionType: ['LOAN'] },
        }),
      },
    ],
  },
  resources: {
    title: 'Resources',
    items: [
      {
        image: 'illustrations/announce-illustration.svg',
        title: 'Join the Idealist Action Incubator',
        description:
          'Connect with a member of our team for one-on-one sessions where you’ll collaboratively develop your action plan.',
        href: '/en/action-incubator',
      },
    ],
  },
};
